import { DateInputValue } from "basis";
import { ActionMap } from "library/ActionMap";
import { AccountInfo } from "library/hooks/types";
import { MakeRequired } from "library/utils";
import { Dispatch } from "react";

export type ScreenComponentType = React.FC<ScreenProps>;
export type PageInfo = {
  [key: string]: {
    heading: string;
    headingIcon?: string;
    screenComponent: ScreenComponentType;
  };
};

export type FormValues = {
  primaryFullName: string;
  primaryDateOfBirth: DateInputValue;
  additionalFullName: string;
  additionalDateOfBirth: DateInputValue;
  authorityOption: string;
  email: string;
  agreeToAdditionalCardHolder: boolean;
  agreeToPrivacyPolicy: boolean;
};

export enum ActionType {
  ACCOUNT_INFO_LOADED = "ACCOUNT_INFO_LOADED",
  FORM_SUBMITTED = "FORM_SUBMITTED",
}

export interface State {
  page: string;
  formValues: FormValues;
  postReduceCreditLimitHref?: string;
  errorType?: string;
  accountInfo?: AccountInfo;
}

type Payloads = {
  [ActionType.ACCOUNT_INFO_LOADED]: {
    accountInfo: AccountInfo;
  };
  [ActionType.FORM_SUBMITTED]: {
    formValues: FormValues;
  };
};

export type Action = ActionMap<ActionType, Payloads>;

export type ScreenState = MakeRequired<State, "accountInfo">;

export type ScreenProps = {
  state: ScreenState;
  dispatch: Dispatch<Action>;
};
